<script lang="ts">
import {
  iButton,
  iButtonStyles,
  iButtonSizes,
  iButtonTypes,
  showToast,
} from '@inscribe/signal';
import UserFeedback from '@/V2/components/user-feedback/UserFeedback.vue';
import { USER_FEEDBACK_RESOURCE_TYPE } from '@/constants/userFeedback';
import { makeChatAgentConversationFeedbackResourceId } from '@/utils/userFeedback';
import { mapGetters } from 'vuex';

export default {
  name: 'ChatMessageAssistantFooter',
  components: { iButton, UserFeedback },
  props: {
    conversationUuid: {
      type: String,
      required: true,
    },
    messageIndex: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {
      iButtonStyles,
      iButtonSizes,
      iButtonTypes,
      USER_FEEDBACK_RESOURCE_TYPE,
    };
  },
  computed: {
    ...mapGetters(['getMessagesForConversationUuid']),
    message() {
      const allMessages =
        this.getMessagesForConversationUuid(this.conversationUuid) ?? [];
      return allMessages[this.messageIndex];
    },
    resourceId() {
      return makeChatAgentConversationFeedbackResourceId(
        this.conversationUuid,
        this.messageIndex,
      );
    },
  },
  methods: {
    copyText() {
      navigator.clipboard.writeText(this.message.content);
      showToast({
        text: `Text copied to Clipboard`,
      });
    },
  },
};
</script>

<template>
  <div class="feedback-container d-flex align-items-center space-between">
    <i-button
      left-icon="medium-copy-1"
      :button-style="iButtonStyles.GHOST"
      :size="iButtonSizes.SMALL"
      :type="iButtonTypes.NEUTRAL"
      @button-click="copyText"
    ></i-button>

    <user-feedback
      :resource-type="USER_FEEDBACK_RESOURCE_TYPE.CHAT_AGENT_CONVERSATION"
      :resource-id="resourceId"
    />
  </div>
</template>

<style lang="scss" scoped>
.feedback-container {
  justify-content: space-between;

  :deep(.i-icon) {
    color: var(--icon-neutral);
  }
}
</style>
